module.exports = __webpack_public_path__ + "static/img/s2.27857a19.png";